import React, { useEffect, useState } from "react";
import { Offcanvas, OffcanvasHeader, OffcanvasBody } from "reactstrap";
import { Controller, useForm } from "react-hook-form";
import ErrorMessage from "./ErrorMessage";
import { useSelector } from "react-redux";
import SearchSelectBox from "./SearchSelectBox";
import SearchSelectInput from "./SearchSelectInput";
import store from "../../store";
import { updateFiltersStates } from "../../store/actions/UserActions";
import MultiSelectDropdown from "./MultiSelectDropdown";

const FilterSidebar = ({
  isOpen,
  toggle,
  categoryData,
  sortHandler,
  sortList,
}) => {
  const { register, handleSubmit, reset, watch, setValue, control } = useForm();
  const [disabled, setDisabled] = useState(true);
  const filterDetails = useSelector((state) => state.root.filtersStates);

  const onSubmit = (data) => {
    // console.log("data in sidebarfilter==>",data);
    sortHandler(data);
    toggle();
  };

  const handleChange = (e) => {
    // const department = watch('department');
    if (e.target.value !== "") {
      const data = {
        department: e.target.value,
      };
      sortHandler(data, "department");
      reset({
        designation: "",
      });
      setDisabled(false);
    } else {
      setDisabled(true);
    }
  };

  useEffect(() => {
    if (sortList?.resetState) {
      reset();
      setDisabled(true);
    }
  }, [sortList?.resetState]);

  useEffect(() => {
    if (!isOpen) return;

    const setOrReset = (field, list, id) => {
      if (id) {
        const foundItem = list?.find((item) => item?.value === id);
        if (foundItem) {
          setValue(field, foundItem);
          return foundItem;
        }
      }
      setValue(field, "");
      return null;
    };

    const customer = setOrReset(
      "customerId",
      sortList?.customerList,
      filterDetails?.customerId
    );

    if (customer?.value) {
      sortList?.fetchCustomerCompanyList("", customer?.value);
    }

    setOrReset(
      "customerCompanyId",
      sortList?.customerCompanyList,
      filterDetails?.customerCompanyId
    );

    const { requestType, stockStatus, department, designation, empStatus } =
      filterDetails || {};
    setValue("requestType", requestType || "");
    setValue("stockStatus", stockStatus || "");
    setValue("department", department || "");
    setValue("designation", designation || "");
    setValue("status", empStatus || "");
    setValue("month", filterDetails?.selectedMonths || []);
  }, [isOpen]);

  return (
    <Offcanvas
      isOpen={isOpen}
      toggle={toggle}
      direction="end"
      className="filters"
    >
      <OffcanvasHeader toggle={toggle} className="p-4 border-bottom" tag="h3">
        Filters
      </OffcanvasHeader>
      <OffcanvasBody className="p-4 ">
        <form
          onSubmit={handleSubmit(onSubmit)}
          className="h-100 d-flex flex-column justify-content-between"
        >
          <div className="row">
            {sortList?.customerList && (
              <div className="form-group mb-3">
                <div className="position-relative ">
                  <Controller
                    name="customerId"
                    control={control}
                    render={({ field: { onChange, value } }) => (
                      <SearchSelectInput
                        label="Customer"
                        placeholder="Search Customer..."
                        options={sortList?.customerList}
                        onSearch={sortList?.fetchCustomerList}
                        isLoading={sortList?.customerIsLoading}
                        showAddButton={false}
                        value={value?.label}
                        onSelect={(option) => {
                          sortList?.fetchCustomerCompanyList("", option?.value);
                          onChange(option);
                        }}
                      />
                    )}
                  />
                </div>
              </div>
            )}
            {sortList?.fetchCustomerCompanyList && (
              <div className="form-group mb-3">
                <div className="position-relative ">
                  <Controller
                    name="customerCompanyId"
                    control={control}
                    render={({ field: { onChange, value } }) => (
                      <SearchSelectInput
                        label="Customer Company"
                        placeholder="Search Customer Company..."
                        options={sortList?.customerCompanyList}
                        onSearch={sortList?.fetchCustomerCompanyList}
                        isLoading={sortList?.customerCompanyIsLoading}
                        showAddButton={false}
                        value={value?.label}
                        onSelect={(option) => {
                          onChange(option);
                        }}
                      />
                    )}
                  />
                </div>
              </div>
            )}
            {sortList?.department && (
              <div className="col-12">
                <div className="form-group mb-3">
                  <label htmlFor="typ" className="form-label">
                    Emp. Dept.
                  </label>
                  <select
                    className="form-select"
                    id="typ"
                    // name="department"
                    {...register("department")}
                    onChange={(e) => handleChange(e)}
                  >
                    <option value={""}>Select Department</option>
                    {sortList?.department?.map((item) => {
                      return (
                        <option key={item.id} value={item.id}>
                          {item.name}
                        </option>
                      );
                    })}
                  </select>
                  {/* {errors.leaveType && <div className="form-text text-danger">{errors.leaveType.message}</div>} */}
                </div>
              </div>
            )}
            {sortList?.userList && (
              <div className="col-12">
                <div className="form-group mb-3">
                  <label htmlFor="d2" className="form-label">
                    User
                  </label>
                  <select
                    className="form-select"
                    aria-label="Default select "
                    {...register("user")}
                  >
                    <option value={""} className="d-none">
                      Select user
                    </option>
                    <option value={""}>All</option>
                    {sortList?.userList &&
                      sortList?.userList?.length > 0 &&
                      sortList?.userList.map((item, i) => {
                        return (
                          <option value={item?.userId || item?.id} key={i}>
                            {item?.user?.name || item?.name}
                          </option>
                        );
                      })}
                  </select>
                </div>
              </div>
            )}
            {sortList?.designation && (
              <div className="col-12">
                <div className="form-group mb-3">
                  <label htmlFor="typ" className="form-label">
                    Designation
                  </label>
                  <select
                    className="form-select"
                    id="typ"
                    {...register("designation")}
                    disabled={disabled}
                  >
                    <option value={""}>Select Designation</option>
                    {sortList?.designation?.map((item) => {
                      return (
                        <option key={item.id} value={item.id}>
                          {item.name}
                        </option>
                      );
                    })}
                  </select>
                  {/* {errors.leaveType && <div className="form-text text-danger">{errors.leaveType.message}</div>} */}
                </div>
              </div>
            )}
            {sortList?.attendanceStatus && (
              <div className="col-12">
                <div className="form-group mb-3">
                  <label htmlFor="typ" className="form-label">
                    Attendance Status
                  </label>
                  <select
                    className="form-select"
                    id="typ"
                    {...register("attendanceStatus")}
                  >
                    {sortList?.attendanceStatus?.map((item, index) => {
                      return (
                        <option key={index} value={item.value}>
                          {item.label}
                        </option>
                      );
                    })}
                  </select>
                  {/* {errors.leaveType && <div className="form-text text-danger">{errors.leaveType.message}</div>} */}
                </div>
              </div>
            )}
            {sortList?.attendanceType && (
              <div className="col-12">
                <div className="form-group mb-3">
                  <label htmlFor="typ" className="form-label">
                    Attendance Type
                  </label>
                  <select
                    className="form-select"
                    id="typ"
                    {...register("attendanceType")}
                  >
                    {sortList?.attendanceType?.map((item, index) => {
                      return (
                        <option key={index} value={item.value}>
                          {item.label}
                        </option>
                      );
                    })}
                  </select>
                  {/* {errors.leaveType && <div className="form-text text-danger">{errors.leaveType.message}</div>} */}
                </div>
              </div>
            )}
            {sortList?.leaveType && (
              <div className="col-12">
                <div className="form-group mb-3">
                  <label htmlFor="typ" className="form-label">
                    Leave Type
                  </label>
                  <select
                    className="form-select"
                    id="typ"
                    {...register("leaveType")}
                  >
                    <option value={""}>Select leave type</option>
                    {sortList?.leaveType?.map((item, index) => {
                      return (
                        <option key={index} value={item?.type}>
                          {item?.type}
                        </option>
                      );
                    })}
                  </select>
                  {/* {errors.leaveType && <div className="form-text text-danger">{errors.leaveType.message}</div>} */}
                </div>
              </div>
            )}
            {sortList?.leaveStatus && (
              <div className="col-12">
                <div className="form-group mb-3">
                  <label htmlFor="typ" className="form-label">
                    Leave Status
                  </label>
                  <select
                    className="form-select"
                    id="typ"
                    {...register("leaveStatus")}
                  >
                    {sortList?.leaveStatus?.map((item, index) => {
                      return (
                        <option key={index} value={item.value}>
                          {item.label}
                        </option>
                      );
                    })}
                  </select>
                  {/* {errors.leaveType && <div className="form-text text-danger">{errors.leaveType.message}</div>} */}
                </div>
              </div>
            )}
            {sortList?.aRStatus && (
              <div className="col-12">
                <div className="form-group mb-3">
                  <label htmlFor="typ" className="form-label">
                    A.R. Status
                  </label>
                  <select
                    className="form-select"
                    id="typ"
                    {...register("aRStatus")}
                  >
                    {sortList?.aRStatus?.map((item, index) => {
                      return (
                        <option key={index} value={item.value}>
                          {item.label}
                        </option>
                      );
                    })}
                  </select>
                  {/* {errors.leaveType && <div className="form-text text-danger">{errors.leaveType.message}</div>} */}
                </div>
              </div>
            )}
            {sortList?.oDStatus && (
              <div className="col-12">
                <div className="form-group mb-3">
                  <label htmlFor="typ" className="form-label">
                    O.D. Status
                  </label>
                  <select
                    className="form-select"
                    id="typ"
                    {...register("oDStatus")}
                  >
                    {sortList?.oDStatus?.map((item, index) => {
                      return (
                        <option key={index} value={item.value}>
                          {item.label}
                        </option>
                      );
                    })}
                  </select>
                  {/* {errors.leaveType && <div className="form-text text-danger">{errors.leaveType.message}</div>} */}
                </div>
              </div>
            )}
            {sortList?.requestTypeList && (
              <div className="col-12">
                <div className="form-group mb-3">
                  <label htmlFor="typ" className="form-label">
                    Request Type
                  </label>
                  <select
                    className="form-select min-w-20 pe-5"
                    id="requestType"
                    {...register("requestType")}
                  >
                    {sortList?.requestTypeList?.map((item) => (
                      <option value={item?.value}>{item?.label}</option>
                    ))}
                  </select>
                </div>
              </div>
            )}
            {sortList?.stockTypeList && (
              <div className="col-12">
                <div className="form-group mb-3">
                  <label htmlFor="typ" className="form-label">
                    Stock Type
                  </label>
                  <select
                    className="form-select min-w-20 pe-5"
                    id="stockStatus"
                    {...register("stockStatus")}
                  >
                    {sortList?.stockTypeList?.map((item) => (
                      <option value={item?.value}>{item?.label}</option>
                    ))}
                  </select>
                </div>
              </div>
            )}
            {sortList?.userStatus && (
              <div className="col-12">
                <div className="form-group mb-3">
                  <label htmlFor="typ" className="form-label">
                    User Status
                  </label>
                  <select
                    className="form-select min-w-20 pe-5"
                    id="status"
                    {...register("status")}
                  >
                    <option value={""} hidden>
                      Select Status
                    </option>
                    <option value="current">Current</option>
                    <option value="exEmployee">Ex-Employee</option>
                  </select>
                </div>
              </div>
            )}
            {sortList?.monthList && (
              <div className="col-12">
                <div className="form-group mb-3">
                  <label htmlFor="typ" className="form-label">
                    Select Month
                  </label>
                  <Controller
                    name="month"
                    control={control}
                    render={({ field: { onChange, value } }) => (
                      <MultiSelectDropdown
                        options={sortList?.monthList}
                        selectedValues={value}
                        onChange={onChange}
                        placeholder="Select Month"
                      />
                    )}
                  />
                </div>
              </div>
            )}
          </div>
          {/* Buttons */}
          <div className="d-flex align-items-center justify-content-end gap-3">
            <button className="btn btn-primary" type="submit">
              Apply Filters
            </button>
            <button
              type="button"
              className="btn btn-secondary"
              onClick={() => {
                sortHandler({});
                reset();
                store.dispatch(
                  updateFiltersStates({
                    customerId: "",
                    customerCompanyId: "",
                    selectedMonths: [],
                  })
                );
                toggle();
                setDisabled(true);
              }}
            >
              Clear All
            </button>
          </div>
        </form>
      </OffcanvasBody>
    </Offcanvas>
  );
};

export default FilterSidebar;
